import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IAccountLock } from "src/store/features/api/generated";
import { useAppSelector } from "src/store/store";

export const STAGES = {
  ACKNOWLEDGE: "acknowledge",
  FORM: "form",
  COMPLETED: "completed",
};

export interface AccountLockState {
  isAccountLockModalOpen: boolean;

  currentStage: string;

  currentAccountLock: IAccountLock | null;
}

const initialState: AccountLockState = {
  isAccountLockModalOpen: false,

  currentStage: STAGES.ACKNOWLEDGE,

  currentAccountLock: null,
};

const AccountLockSlice = createSlice({
  name: "accountLock",
  initialState: initialState,
  reducers: {
    toggleAccountLockModal: (state: AccountLockState): void => {
      state.isAccountLockModalOpen = !state.isAccountLockModalOpen;
    },
    setCurrentStage: (state: AccountLockState, action: PayloadAction<string>): void => {
      state.currentStage = action.payload;
    },
    setCurrentAccountLock: (state: AccountLockState, action: PayloadAction<IAccountLock>): void => {
      state.currentAccountLock = action.payload;
    },
  },
});

export const { toggleAccountLockModal, setCurrentStage, setCurrentAccountLock } =
  AccountLockSlice.actions;

export const useAccountLockState = () => useAppSelector((state) => state.accountLock);

export default AccountLockSlice;
